import { render, staticRenderFns } from "./CliffUluru.vue?vue&type=template&id=020813a3&"
import script from "./CliffUluru.vue?vue&type=script&lang=js&"
export * from "./CliffUluru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports